module.exports = __webpack_public_path__ + "img/yonimo-logo@2x.4da1e39a.png";